import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export var res;
export const defectListTodo = createAsyncThunk('defectList', async (data) => {
    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'defect',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },
        })
        return res
    } catch (error) {
        return error?.response
    }
});

const defectListSlice = createSlice({
    name: 'defectList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(defectListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status == 401) {
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            }
            // else if (action?.payload?.status == 400 || action?.payload?.status == 404) {
            //     toast.error(action?.payload?.status == 400 ? res?.payload?.data?.message : 'Not Found', { position: "bottom-right" });
            // state.data = []
            // } 
            else {
                state.data = []
                // toast.error('Something Went Wrong...!!', { position: "bottom-right" });
            }
        });
        builder.addCase(defectListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default defectListSlice.reducer; 